var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15622_284553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z",
    fill: "#EF5350"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 14,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0013 1.16797C13.7755 1.16797 11.168 3.77547 11.168 7.0013C11.168 10.2271 13.7755 12.8346 17.0013 12.8346C20.2271 12.8346 22.8346 10.2271 22.8346 7.0013C22.8346 3.77547 20.2271 1.16797 17.0013 1.16797ZM19.918 9.09547L19.0955 9.91797L17.0013 7.8238L14.9071 9.91797L14.0846 9.09547L16.1788 7.0013L14.0846 4.90714L14.9071 4.08464L17.0013 6.1788L19.0955 4.08464L19.918 4.90714L17.8238 7.0013L19.918 9.09547Z",
    fill: "#EF5350"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15622_284553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneError);
export default __webpack_public_path__ + "static/media/phone_error.1fb9c652f2f37cb62c075e5aae8605f5.svg";
export { ForwardRef as ReactComponent };